var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultichainSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.583 33.8833L218.974 35.5545C217.884 34.9248 216.746 34.3435 215.583 33.8833Z",
    stroke: "url(#paint0_linear_2501_1430)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.534 11.3348C168.5 10.1964 166.393 9.20351 164.188 8.42847L172.472 12.5215C171.842 12.1098 171.188 11.6981 170.534 11.3348Z",
    stroke: "url(#paint1_linear_2501_1430)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.962 56.9661C233.288 47.2538 226.966 40.1086 218.974 35.5552L215.583 33.8843L215.292 33.7387C208.123 30.5174 199.937 29.3067 190.757 30.0575C189.934 30.1301 189.11 30.2028 188.287 30.3239C178.187 31.5591 167.457 35.4586 156.098 42.0223C143.794 49.1188 132.241 58.4675 121.439 70.069C116.547 75.3005 111.969 80.7745 107.658 86.4663C102.402 93.369 97.6062 100.587 93.2224 108.143C92.738 108.991 92.2538 109.839 91.7694 110.711C84.4549 123.741 78.6176 137.304 74.2338 151.497C69.5593 166.586 67.2344 181.191 67.2344 195.288C67.2344 209.384 69.5593 221.3 74.2338 231.012C74.6213 231.86 75.0573 232.659 75.469 233.459C79.9982 241.936 85.9079 248.257 93.2224 252.423C101.215 257 110.637 258.817 121.439 257.945C132.241 257.049 143.794 253.052 156.098 245.956C168.378 238.859 179.931 229.511 190.757 217.909C201.56 206.332 210.957 193.641 218.974 179.835C226.966 166.03 233.288 151.594 237.962 136.505C242.613 121.392 244.962 106.787 244.962 92.6909C244.962 78.5947 242.613 66.6784 237.962 56.9661ZM156.098 143.989L107.658 116.378L105.672 115.24C106.326 114.126 106.98 113.012 107.658 111.922C113.834 101.749 120.882 92.5453 128.778 84.3105C137.521 75.1794 146.628 67.8894 156.098 62.4156V143.989Z",
    stroke: "url(#paint2_linear_2501_1430)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.099 62.4155V143.989L107.659 116.378L105.673 115.24C106.327 114.126 106.981 113.011 107.659 111.922C113.835 101.749 120.883 92.5452 128.779 84.3103C137.522 75.1793 146.629 67.8893 156.099 62.4155Z",
    stroke: "url(#paint3_linear_2501_1430)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.187 8.42796L164.042 8.35522",
    stroke: "url(#paint4_linear_2501_1430)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.292 33.7383C208.123 30.517 199.937 29.3063 190.757 30.0571C189.934 30.1297 189.11 30.2022 188.287 30.3233C178.187 31.5585 167.457 35.4579 156.098 42.0216C143.794 49.1181 132.241 58.4671 121.439 70.0686C116.547 75.3001 111.969 80.7739 107.658 86.4657C102.402 93.3684 97.6063 100.586 93.2224 108.143C92.738 108.99 92.2538 109.838 91.7694 110.71C84.4549 123.741 78.6176 137.304 74.2338 151.497C69.5593 166.586 67.2344 181.191 67.2344 195.287C67.2344 209.383 69.5593 221.299 74.2338 231.012C74.6213 231.859 75.0573 232.659 75.469 233.458C79.9982 241.935 85.9079 248.257 93.2224 252.423L48.5604 230.091L44.782 228.202C36.7895 223.649 30.468 216.504 25.7935 206.792C21.119 197.079 18.7939 185.187 18.7939 171.067C18.7939 156.946 21.119 142.366 25.7935 127.277C30.468 112.163 36.7895 97.728 44.782 83.9225C52.7747 70.1413 62.1966 57.4257 72.9988 45.8484C83.801 34.2469 95.354 24.8979 107.658 17.8014C119.938 10.7049 131.491 6.70874 142.317 5.83681C150.382 5.15864 157.672 6.03043 164.188 8.42822L172.471 12.5213L172.543 12.5698L215.292 33.7383Z",
    stroke: "url(#paint5_linear_2501_1430)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_1430",
    x1: 217.278,
    y1: 33.8833,
    x2: 217.278,
    y2: 35.5545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_1430",
    x1: 168.33,
    y1: 8.42847,
    x2: 168.33,
    y2: 12.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_1430",
    x1: 156.098,
    y1: 29.8423,
    x2: 156.098,
    y2: 258.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_1430",
    x1: 130.886,
    y1: 62.4155,
    x2: 130.886,
    y2: 143.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2501_1430",
    x1: 164.115,
    y1: 8.35522,
    x2: 164.115,
    y2: 8.42796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2501_1430",
    x1: 117.043,
    y1: 5.61401,
    x2: 117.043,
    y2: 252.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultichainSupport);
export default __webpack_public_path__ + "static/media/Multichain-Support.5c94e5ec0eaa8fd4a3e14a04c1fcbb9d.svg";
export { ForwardRef as ReactComponent };